import React from 'react';
import { Box, TextField } from '@mui/material';

interface FileSearchBarProps {
  search: string;
  setSearch: (value: string) => void;
}

const FileSearchBar: React.FC<FileSearchBarProps> = ({ search, setSearch }) => {
  return (
    <Box sx={{ width: '100%', height: '100%', px: 0 }}>
      <TextField
        fullWidth
        placeholder="Search files"
        variant="outlined"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    </Box>
  );
};

export default FileSearchBar;